import dayjs from 'dayjs';

export class DateUtils {
  static formatDateTime(date: Date | string | undefined | null): string {
    if (!date) return 'N/A';
    
    const dayjsInstance = dayjs(date);
    if (!dayjsInstance.isValid()) {
      return 'N/A';
    }

    return dayjsInstance.format('YYYY-MM-DD HH:mm:ss');
  }
}